function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import _join from 'lodash/join';
import _deburr from 'lodash/deburr';
import _orderBy from 'lodash/orderBy';
import { translateFieldName, getNewURL, objectifyParameters, translate } from '../utils/helpers';

var SidebarFilter = /*#__PURE__*/function (_Component) {
  _inherits(SidebarFilter, _Component);

  var _super = _createSuper(SidebarFilter);

  function SidebarFilter(props) {
    var _this;

    _classCallCheck(this, SidebarFilter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleFilter", function (name) {
      var filters = _this.state.filters;

      if (filters.includes(name)) {
        filters = filters.filter(function (n) {
          return n !== name;
        });
      } else {
        filters.push(name);
      }

      _this.setState({
        filters: filters
      }, function () {
        _this.props.history.push(getNewURL(_this.objectifiedParameters, _this.props.slug.toLowerCase(), _join(_this.state.filters, '+')));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "isChecked", function (checkboxId) {
      if (_this.state.filters !== undefined) {
        return _this.state.filters.find(function (filter) {
          return parseInt(filter, 10) === checkboxId;
        }) !== undefined;
      } else {
        return false;
      }
    });

    _this.state = {
      filters: [],
      ready: false
    };
    _this.objectifiedParameters = objectifyParameters(_this.props.match.params);
    return _this;
  }

  _createClass(SidebarFilter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        filters: this.objectifiedParameters[this.props.slug.toLowerCase()] !== undefined ? this.objectifiedParameters[this.props.slug.toLowerCase()] : [],
        ready: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.objectifiedParameters = objectifyParameters(this.props.match.params);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var filters = this.props.filters;
      var title = translate(this.props.titleEn, this.props.titleFr);
      var slug = this.props.slug;
      return filters.length > 1 ? /*#__PURE__*/React.createElement("div", {
        className: "filter-sidebar-card second-bg"
      }, /*#__PURE__*/React.createElement("div", {
        className: "filter-title-box"
      }, /*#__PURE__*/React.createElement("div", {
        className: "title uppercase"
      }, title)), /*#__PURE__*/React.createElement("div", {
        className: "certifications-container"
      }, this.state.ready && _orderBy(filters, [function (filter) {
        return _deburr(filter[translateFieldName('name')]);
      }]).map(function (filter) {
        return /*#__PURE__*/React.createElement("div", {
          key: filter.id,
          className: "custom-control solid-checkbox"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          className: "custom-control-input main-bg-before",
          id: "".concat(slug.toLowerCase() + filter.id),
          checked: _this2.isChecked(filter.id),
          onChange: function onChange() {
            return _this2.toggleFilter("".concat(filter.id));
          }
        }), /*#__PURE__*/React.createElement("label", {
          className: "custom-control-label first-uppercase",
          htmlFor: "".concat(slug.toLowerCase() + filter.id)
        }, filter[translateFieldName('name')]));
      }))) : null;
    }
  }]);

  return SidebarFilter;
}(Component);

SidebarFilter.propTypes = {
  filters: PropTypes.array,
  titleFr: PropTypes.string,
  titleEn: PropTypes.string,
  slug: PropTypes.string,
  history: PropTypes.object,
  match: PropTypes.object
};
export default withRouter(SidebarFilter);